import { Breadcrumb } from '@ntconsult/aluma-react';
import { useUIStore } from '@store/uiStore';
import { useTranslation } from 'react-i18next';
import { Link, useMatches } from 'react-router-dom';
import type { RouteHandle } from './routeHandle';

/**
 * Trilha da página atual, acima do `PageHeader` de toda tela do `Layout`: nome
 * do módulo (link para `/`) › grupo do sidebar, quando houver › página. Lê o
 * `handle` da rota mais interna, o mesmo que dá o título da aba. Fica no
 * `Layout`, e não no slot `breadcrumb` do `PageHeader`, para valer em toda tela
 * sem repetir.
 */
export function PageBreadcrumb() {
  const { t } = useTranslation(['common', 'auth']);
  const focusSidebarSubMenu = useUIStore((s) => s.focusSidebarSubMenu);
  const handle = useMatches()
    .map((match) => match.handle as RouteHandle | undefined)
    .findLast((h) => h?.title);
  if (!handle?.title) return null;

  return (
    <Breadcrumb aria-label={t('common:breadcrumb')}>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link asChild>
            <Link to="/">{t('common:appName')}</Link>
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        {handle.section && (
          <>
            <Breadcrumb.Separator />
            <Breadcrumb.Item>
              {handle.sectionId ? (
                <Breadcrumb.Link asChild>
                  <button
                    type="button"
                    className="cursor-pointer"
                    onClick={() => handle.sectionId && focusSidebarSubMenu(handle.sectionId)}
                  >
                    {handle.section(t)}
                  </button>
                </Breadcrumb.Link>
              ) : (
                handle.section(t)
              )}
            </Breadcrumb.Item>
          </>
        )}
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Page>{handle.title(t)}</Breadcrumb.Page>
        </Breadcrumb.Item>
      </Breadcrumb.List>
    </Breadcrumb>
  );
}
